import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Icon } from '@plone/volto/components';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';

import alertSVG from '@plone/volto/icons/alert.svg';
import docSVG from '@redturtle/volto-io-studio/icons/document.svg';

/* STYLE */
import './alert.less';

const View = (props) => {
  const { data, className } = props;

  return (
    <>
      {data.title || data.text ? (
        <div className={cx(className, 'block alert view')}>
          <div
            className={cx('alert-wrapper', {
              'with-icon': data.icon !== 'none',
            })}
          >
            {data.icon !== 'none' && (
              <div className="icon-wrapper">
                <Icon
                  className={data.icon}
                  name={data.icon === 'alert' ? alertSVG : docSVG}
                />
              </div>
            )}
            <div className="content">
              {data?.title && (
                <div className="title">
                  <h2>{data?.title}</h2>
                </div>
              )}
              {data?.text && (
                <div className="text">
                  <TextBlockView data={{ value: data?.text }} />
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
